import axiosUrl from "./axios.service";
import axios from "axios";
import store from "../store/index";
import moment from "moment";
import UserService from "./userprofile.service";
import Cookies from "js-cookie";
import router from "../router/index";

import { computed } from "vue";
const API_URL = axiosUrl.getAxiosUrl();

const currentPage = computed({
  get: () => store.state.advancedSearch.currentPage,
});
const applicationLanguage = computed({
  get: () => store.state.auth.applicationLanguageCode,
});

class GrantsService {
  // not in use?
  async loadDefaultSchemes() {
    return await axios
      .get(API_URL + "/search/searchschemes", {
        params: {
          PageSize: 10,
          Page: currentPage.value - 1,
          Statusses: "Open,Forthcoming,",
          Sort: "Relevantie",
        },
      })
      .then((response) => {
        store.commit("grantItems/updateGrants", response.data);
        if (response.data.resultCount % 10 != 0)
          store.commit(
            "advancedSearch/updatePageCount",
            response.data.pageCount + 1
          );
        else
          store.commit(
            "advancedSearch/updatePageCount",
            response.data.pageCount
          );
        store.commit(
          "advancedSearch/updateResultsCount",
          response.data.resultCount
        );
        store.commit("grantItems/disableSearchPageLoading");
        store.commit("advancedSearch/disableFiltersChange");
        store.commit("portalsData/updateIsPortalPageLoading", false);
      });
  }

  async downloadDocument(documentId) {
    return await axios
      .get(API_URL + `/scheme/download?documentId=${documentId}`, {
        responseType: "blob",
        reportProgress: true,
      })
      .catch((error) => {
        if (error)
          store.commit("scheme/updateModalError", error.response),
            store.commit("scheme/enableModalError");
      });
  }

  async getSearchResults(
    locale,
    searchText,
    schemeStatusGroup,
    audiences,
    locations,
    //This is just hidden for now, don't remove it:
    //industries,
    purposes,
    schemeTypes,
    projectTypes,
    smeString,
    applicationTermsString,
    minBudget,
    maxBudget,
    scopesString,
    orgsIncludeString,
    orgsExcludeString,
    startDate,
    endDate,
    sort,
    complexityRating,
    chanceOfSuccessRating,
    timeForApplicationRating,
    industriesNew
  ) {
    const start =
      startDate != null &&
      startDate.value != null &&
      startDate.value != "" &&
      startDate.value != '""' &&
      startDate.value != "null"
        ? moment(startDate.value, "DD-MM-YYYY").format("YYYY-MM-DD")
        : null;
    const end =
      endDate != null &&
      endDate.value != null &&
      endDate.value != "" &&
      endDate.value != '""' &&
      endDate.value != "null"
        ? moment(endDate.value, "DD-MM-YYYY").format("YYYY-MM-DD")
        : null;

    return await axios
      .get(API_URL + "/search/searchschemes", {
        params: {
          Term: searchText.value,
          PageSize: 10,
          Page: currentPage.value - 1,
          Sort: sort.value,
          Statusses: schemeStatusGroup,
          AudienceTags: audiences.value,
          //This is just hidden for now, don't remove it
          // IndustriesTags: industries.value,
          PurposesTags: purposes.value,
          SchemeTypesTags: schemeTypes.value,
          ProjectTypesTags: projectTypes.value,
          LocationsTags:
            applicationLanguage.value === "nl" ? locations.value : null,
          GermanLocationsTags:
            applicationLanguage.value === "de" ? locations.value : null,
          AppliesToSME: smeString.value,
          ApplicationTerms: applicationTermsString.value,
          MinAmount: minBudget.value != 0 ? minBudget.value : null,
          MaxAmount: maxBudget.value != 0 ? maxBudget.value : null,
          Scopes: scopesString.value,
          NotOrganisations:
            orgsExcludeString.value.length > 0 ? orgsExcludeString.value : null,
          Organisations:
            orgsIncludeString.value.length > 0 ? orgsIncludeString.value : null,
          CallStartDate: start,
          CallEndDate: end,
          ComplexityRating: complexityRating ? complexityRating.value : null,
          ChanceOfSuccessRating: chanceOfSuccessRating
            ? chanceOfSuccessRating.value
            : null,
          TimeForApplicationRating: timeForApplicationRating
            ? timeForApplicationRating.value
            : null,
          culture: locale.value,
          IndustriesNewTags:
            industriesNew != null && industriesNew.value != null
              ? industriesNew.value
              : null,
        },
      })
      .then((response) => {
        store.commit("grantItems/updateGrants", response.data);
        if (response.data.resultCount % 10 != 0)
          store.commit(
            "advancedSearch/updatePageCount",
            response.data.pageCount + 1
          );
        else
          store.commit(
            "advancedSearch/updatePageCount",
            response.data.pageCount
          );
        store.commit(
          "advancedSearch/updateResultsCount",
          response.data.resultCount
        );
        store.commit("advancedSearch/updateMaxScoreOnCurrentPage");
        store.commit("advancedSearch/updateMaxScore", response.data.topScore);
        store.commit("user/setIsProfileSearch", false);
        store.commit("advancedSearch/disableFiltersChange");
        store.commit("grantItems/disableSearchPageLoading");
        store.commit("portalsData/updateIsPortalPageLoading", false);
        store.commit("grantItems/clearSelectedResults");
      });
  }

  async getResulstsByPage(
    locale,
    current,
    searchText,
    schemeStatusGroup,
    audiences,
    locations,
    //This is just hidden for now, don't remove it:
    //industries,
    purposes,
    schemeTypes,
    projectTypes,
    smeString,
    applicationTermsString,
    minBudget,
    maxBudget,
    scopesString,
    orgsIncludeString,
    orgsExcludeString,
    startDate,
    endDate,
    sort,
    complexityRating,
    chanceOfSuccessRating,
    timeForApplicationRating,
    industriesNew
  ) {
    return await axios
      .get(API_URL + "/search/searchschemes", {
        params: {
          Term: searchText.value,
          PageSize: 10,
          Page: current,
          Sort: sort.value,
          Statusses: schemeStatusGroup,
          AudienceTags: audiences.value,
          //This is just hidden for now, don't remove it
          // IndustriesTags: industries.value,
          PurposesTags: purposes.value,
          SchemeTypesTags: schemeTypes.value,
          ProjectTypesTags: projectTypes.value,
          LocationsTags:
            applicationLanguage.value === "nl" ? locations.value : null,
          GermanLocationsTags:
            applicationLanguage.value === "de" ? locations.value : null,
          AppliesToSME: smeString.value,
          ApplicationTerms: applicationTermsString.value,
          MinAmount: minBudget.value != 0 ? minBudget.value : null,
          MaxAmount: maxBudget.value != 0 ? maxBudget.value : null,
          Scopes: scopesString.value,
          NotOrganisations:
            orgsExcludeString.value.length > 0 ? orgsExcludeString.value : null,
          Organisations:
            orgsIncludeString.value.length > 0 ? orgsIncludeString.value : null,
          CallStartDate:
            startDate.value != null &&
            startDate.value != '""' &&
            startDate.value != ""
              ? moment(startDate.value, "DD-MM-YYYY").format("YYYY-MM-DD")
              : null,
          CallEndDate:
            endDate.value != null &&
            endDate.value != '""' &&
            endDate.value != ""
              ? moment(endDate.value, "DD-MM-YYYY").format("YYYY-MM-DD")
              : null,
          ComplexityRating: complexityRating ? complexityRating.value : null,
          ChanceOfSuccessRating: chanceOfSuccessRating
            ? chanceOfSuccessRating.value
            : null,
          TimeForApplicationRating: timeForApplicationRating
            ? timeForApplicationRating.value
            : null,
          IndustriesNewTags:
            industriesNew != null && industriesNew.value != null
              ? industriesNew.value
              : null,
          culture: locale.value,
        },
      })
      .then((response) => {
        store.commit("grantItems/updateGrants", response.data);
        if (response.data.resultCount % 10 != 0)
          store.commit(
            "advancedSearch/updatePageCount",
            response.data.pageCount + 1
          );
        else
          store.commit(
            "advancedSearch/updatePageCount",
            response.data.pageCount
          );
        store.commit(
          "advancedSearch/updateResultsCount",
          response.data.resultCount
        );
        store.commit("advancedSearch/disableFiltersChange");
        store.commit("grantItems/disableSearchPageLoading");
        store.commit("portalsData/updateIsPortalPageLoading", false);
        store.commit(
          "grantItems/updateSelectAllSchemesCheckboxBasedOnPagination",
          response.data.results.map((x) => Number(x.id))
        );
      });
  }

  async getSchemeById(id, includeChildren, locale) {
    var urlParams = new URLSearchParams(window.location.search);
    return await axios
      .get(API_URL + "/scheme/getScheme", {
        params: {
          schemeId: id,
          terms: urlParams.get("t"),
          includeChildren: includeChildren,
          culture: locale.value,
        },
      })
      .then((response) => {
        store.commit("grantItems/updateSelectedGrant", response.data);
        store.commit("grantItems/disableGrantDetailsLoading");
      })
      .catch((error) => {
        router.push({ name: "SearchGrants" });
        store.commit("user/updateModalError", error.response.data),
          store.commit("user/enableModalError");
      });
  }

  async translateScheme(schemeId, locale) {
    return await axios
      .post(
        API_URL + `/scheme/translateScheme`,
        {
          Id: schemeId,
          translateToLanguageCode: locale.value,
        },
        {
          params: {
            culture: locale.value,
          },
        }
      )
      .then((response) => {
        store.commit("grantItems/updateSelectedGrant", response.data);
      });
  }

  async saveSearch(savedSearch, schemeSearchFilters, locale) {
    return await axios
      .post(
        API_URL + `/search/saveSchemesSearch`,
        {
          title: savedSearch.title,
          isSchemesFilter: true,
          folderId: savedSearch.folder != null ? savedSearch.folder.id : null,
          folderName:
            savedSearch.folder == null || savedSearch.folder.id == 0
              ? savedSearch.newFolderName
              : savedSearch.folder.name,
          filter: {
            term: schemeSearchFilters.searchText,
            pageSize: 10,
            page: 0,
            appliesToSME: schemeSearchFilters.smeTypes,
            scopes: schemeSearchFilters.scopesString,
            applicationTerms: schemeSearchFilters.termsString,
            statusses: schemeSearchFilters.statuses,
            callStartDate:
              schemeSearchFilters.startDate != null &&
              schemeSearchFilters.startDate != ""
                ? moment(schemeSearchFilters.startDate, "DD-MM-YYYY").format(
                    "YYYY-MM-DD"
                  )
                : null,
            callEndDate:
              schemeSearchFilters.endDate != null &&
              schemeSearchFilters.endDate != ""
                ? moment(schemeSearchFilters.endDate, "DD-MM-YYYY").format(
                    "YYYY-MM-DD"
                  )
                : null,
            audienceTags: schemeSearchFilters.audienceTags,
            purposesTags: schemeSearchFilters.purposesTags,
            //This is just hidden for now, don't remove it:
            //industriesTags: schemeSearchFilters.industriesTags,
            locationsTags: schemeSearchFilters.locationsTags,
            schemeTypesTags: schemeSearchFilters.schemeTypesTags,
            projectTypesTags: schemeSearchFilters.projectTypesTags,
            organisations: schemeSearchFilters.organisationsInclude,
            notOrganisations: schemeSearchFilters.organisationsExclude,
            minAmount: schemeSearchFilters.minBudget,
            maxAmount: schemeSearchFilters.maxBudget,
          },
        },
        {
          params: {
            culture: locale.value,
          },
        }
      )
      .then((res) => {
        if (res.status === 200) {
          store.commit("user/disableSave");
          store.commit("user/enableShowSavedSearchInfoDialog", res.data);
          //router.push({ name: 'UserProfile', params: { tab: 'savedItems' } });
        }
      })
      .catch((error) => {
        if (error)
          store.commit("user/updateModalError", error.response.data),
            store.commit("user/enableModalError");
      });
  }

  async postFormAndDownload(url, formData) {
    const xsrfCookieKey = localStorage.getItem("xsrf-cookie-key");
    const token = Cookies.get(xsrfCookieKey);

    const response = await fetch(url, {
      method: "POST",
      credentials: "include",
      headers: {
        "X-XSRF-TOKEN": token,
      },
      body: formData,
    });

    if (!response.ok) {
      throw new Error(
        `Download failed: ${response.status} ${response.statusText}`
      );
    }

    // 1) pull filename from headers
    const contentDisp = response.headers.get("content-disposition") || "";
    const match = contentDisp.match(/filename\*?=(?:UTF-8'')?"?([^";]+)"?/);
    const filename = match ? decodeURIComponent(match[1]) : "download";

    // 2) read blob + download
    const blob = await response.blob();
    const urlObj = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = urlObj;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    URL.revokeObjectURL(urlObj);
  }

  async removeSavedSearch(searchId, folderId) {
    return await axios
      .post(API_URL + `/search/removeSchemesSearch`, {
        id: searchId,
        isSchemesFilter: true,
        folderId: folderId,
      })
      .catch((error) => {
        if (error)
          store.commit("user/updateModalError", error.response.data),
            store.commit("user/enableModalError");
      });
  }

  async hideScheme(schemeId, locale) {
    return axios({
      method: "post",
      url: API_URL + `/scheme/hideScheme`,
      params: {
        schemeId: schemeId,
        culture: locale.value,
      },
    })
      .then((response) => {
        if (response.status == 200)
          store.commit("user/enableShowHiddenInfoDialog");
      })
      .catch((error) => {
        if (error)
          store.commit("scheme/updateModalError", error.response.data),
            store.commit("scheme/enableModalError");
      });
  }

  async unhideAllSchemes() {
    return axios({
      method: "post",
      url: API_URL + `/scheme/unhideAllSchemes`,
    })
      .then((res) => {
        if (res.status === 200) {
          UserService.getHiddenSchemes();
        }
      })
      .catch((error) => {
        if (error)
          store.commit("scheme/updateModalError", error.response.data),
            store.commit("scheme/enableModalError");
      });
  }

  async unhideScheme(schemeId, locale) {
    return axios({
      method: "post",
      url: API_URL + `/scheme/unhideScheme`,
      params: {
        schemeId: schemeId,
        culture: locale.value,
      },
    })
      .then((res) => {
        if (res.status === 200) {
          UserService.getHiddenSchemes();
        }
      })
      .catch((error) => {
        if (error)
          store.commit("scheme/updateModalError", error.response.data),
            store.commit("scheme/enableModalError");
      });
  }

  async getSchemeCustomers(id) {
    return await axios
      .get(API_URL + "/scheme/getSchemeCustomers", {
        params: {
          schemeId: id,
        },
      })
      .then((response) => {
        store.commit("grantItems/updateSchemeCustomers", response.data);
      });
  }

  async searchNewestSchemes(locale, page, size) {
    return await axios
      .get(API_URL + "/search/searchschemes", {
        params: {
          PageSize: size,
          Page: page,
          Sort: "Datum",
          culture: locale.value,
        },
      })
      .then((response) => {
        if (page > 0) {
          store.commit("homePageItems/updateGrantsNewest", response.data);
        } else {
          store.commit("homePageItems/updateGrantsNewest", response.data);

          store.commit("grantItems/updateNewestGrants", response.data);
        }
      });
  }

  async searchNewestSchemesTags(
    locale,
    page,
    size,
    audiences,
    purposes,
    locations
  ) {
    return await axios
      .get(API_URL + "/search/searchschemes", {
        params: {
          PageSize: size,
          Page: page,
          Sort: "Datum",
          AudienceTags: audiences.length > 0 ? audiences : null,
          PurposesTags: purposes.length > 0 ? purposes : null,
          LocationsTags:
            applicationLanguage.value === "nl" && locations.length > 0
              ? locations
              : null,
          GermanLocationsTags:
            applicationLanguage.value === "de" && locations.length
              ? locations
              : null,
          culture: locale.value,
        },
      })
      .then((response) => {
        if (page > 0) {
          store.commit("homePageItems/updateGrantsNewest", response.data);
        } else {
          store.commit("homePageItems/updateGrantsNewest", response.data);

          store.commit("grantItems/updateNewestGrants", response.data);
        }
      });
  }

  async searchSchemesByDeadlineTags(
    locale,
    page,
    size,
    audiences,
    purposes,
    locations
  ) {
    return await axios
      .get(API_URL + "/search/searchschemes", {
        params: {
          PageSize: size,
          Page: page,
          Sort: "Deadline",
          AudienceTags: audiences.length > 0 ? audiences : null,
          PurposesTags: purposes.length > 0 ? purposes : null,
          LocationsTags:
            applicationLanguage.value === "nl" && locations.length > 0
              ? locations
              : null,
          GermanLocationsTags:
            applicationLanguage.value === "de" && locations.length
              ? locations
              : null,
          culture: locale.value,
        },
      })
      .then((response) => {
        if (page > 0) {
          store.commit("homePageItems/updateGrantsByDeadline", response.data);
        } else {
          store.commit("homePageItems/updateGrantsByDeadline", response.data);

          store.commit("grantItems/updateDeadlineGrants", response.data);
        }
      });
  }

  async searchSchemesByDeadline(locale, page, size) {
    return await axios
      .get(API_URL + "/search/searchschemes", {
        params: {
          PageSize: size,
          Page: page,
          Sort: "Deadline",
          culture: locale.value,
        },
      })
      .then((response) => {
        if (page > 0) {
          store.commit("homePageItems/updateGrantsByDeadline", response.data);
        } else {
          store.commit("homePageItems/updateGrantsByDeadline", response.data);

          store.commit("grantItems/updateDeadlineGrants", response.data);
        }
      });
  }

  async searchSignificantSchemes(page, size, locale) {
    return await axios
      .get(
        API_URL +
          "/search/getSchemesWithLastSignificantUpdatesBasedOnFavoriteTags",
        {
          params: {
            PageSize: size,
            Page: page,
            culture: locale.value,
          },
        }
      )
      .then((response) => {
        if (page > 0) {
          store.commit("homePageItems/updateGrantsSignificant", response.data);
        } else {
          store.commit("homePageItems/updateGrantsSignificant", response.data);

          store.commit(
            "grantItems/updateSignificantChangesGrants",
            response.data
          );
        }
      });
  }
  async getSchemeStatuses() {
    return await axios
      .get(API_URL + "/scheme/getSchemeStatuses", {})
      .then((response) => {
        store.commit("grantItems/fillSchemeStatusOptions", response.data);
      });
  }
}

export default new GrantsService();
